<div [ngClass]="{'card mb-2 wow detalle-cliente': true, disabledContent: !enabled}">

  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col">
        <h5>Documento pendiente por pagar</h5>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col"><mdb-checkbox (click)="checkAllDoctoPendiente()"></mdb-checkbox></th>
            <th scope="col">Nro. Doc</th>
            <th scope="col">Emisión</th>
            <th scope="col">Vencimiento</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col" class="text-center">Abono</th>
            <th scope="col" class="text-center">A pagar</th>
            <th scope="col" class="text-right">Deuda</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let deu of listaDeuda">
            <td><mdb-checkbox [(ngModel)]="deu.seleccion" [checked]="deu.seleccion"
                (change)='checkDoctoPendiente(deu)'></mdb-checkbox></td>
            <td>{{deu.folio}}</td>
            <td>{{deu.fecha_emision | fecha}}</td>
            <td>{{deu.fechaVencimientoDocto | fecha}}</td>
            <td class="text-right">{{deu.monto | numerico}}</td>
            <td class="text-center">{{deu.pago | numerico}}</td>
            <td style="width: 130px" class="text-right">
              <input type="text" id="txtMontoAcumulado" class="form-control" placeholder="" step="1" min="0"
                [(ngModel)]="deu.abono" (change)="sumaConforme()" monto />
            </td>
            <td class="text-right">{{deu.deuda | numerico}}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td colspan="4"><strong>Totales</strong></td>
            <td class="text-right"><strong>{{listaTotales.total_monto | numerico}}</strong></td>
            <td class="text-center"><strong>{{listaTotales.total_pago | numerico}}</strong></td>
            <td class="text-center"><strong>{{listaTotales.total_abono | numerico}}</strong></td>
            <td class="text-right"><strong>{{listaTotales.total_deuda | numerico}}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer text-muted filtros-footer justify-content-end align-items-center"
      style="border-top: 1px solid #dee2e6">
      <h6></h6>
    </div>
    <div class="row filtros-body">
      <div class="col">
        <h5>Documentos de Canje y Notas de Credito</h5>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col"><mdb-checkbox (click)="checkAllDoctoCanje()"></mdb-checkbox></th>
            <th scope="col">Tipo Doc.</th>
            <th scope="col">Emisión</th>
            <th scope="col">Vencimiento</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col" class="text-right">Saldo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let can of listaCanje">
            <td><mdb-checkbox [(ngModel)]="can.seleccion" [checked]="can.seleccion"
                (change)='checkDoctoCanje(can)'></mdb-checkbox></td>
            <td>{{can.tipo_pago}}</td>
            <td>{{can.fecha_emision | fecha}}</td>
            <td>{{can.fecha_vencimiento | fecha}}</td>
            <td class="text-right">{{can.monto | numerico}}</td>
            <td class="text-right">{{can.deuda | numerico}}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="4">
              <strong>Total en Nota de Crédito</strong>
            </td>
            <td class="text-right"><strong>{{listaTotalesCanje.total_monto | numerico}}</strong></td>
            <td class="text-right"><strong>{{listaTotalesCanje.total_deuda | numerico}}</strong></td>
          </tr>
          <tr>
            <td class="text-right" colspan="4">
              <strong>Total a Usar</strong>
            </td>
            <td class="text-right"></td>
            <td class="text-right"><strong>{{listaTotalesCanje.total_abono | numerico}}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer justify-content-end align-items-center"
      style="border-top: 1px solid #dee2e6">
      <h6><strong>Diferencial a pagar</strong> {{totalConforme | numerico}} </h6>

      <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="enviaConforme()"
        [disabled]="!habilitaConforme">
        Continuar
      </button>
    </div>
  </div>

</div>